import React from 'react';
import { withRouter } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import routes from '../../routes';
import NotFound from '../../routes/notFound/NotFound';
import ScrollToTop from '../ScrollToTop/ScrollToTop';

class RouteBundler extends React.Component {
  render() {
    return (
      <ScrollToTop>
        <Switch>
          {routes.map(route =>
            <Route
              key={route.path}
              path={route.path}
              component={route.component}
              exact={route.exact}
            />,
          )}
          <NotFound />
        </Switch>
      </ScrollToTop>
    );
  }
}

export default withRouter(RouteBundler);



// WEBPACK FOOTER //
// ./src/components/RouteBundler/RouteBundler.js